import { AlertPopup, HttpLoader } from './../../app.config';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { config } from '../../app.config';
import { ValidationService } from '../form-validation/validation.service';
import { UserService } from './../userandgroup/user/user.service';
import { isPlatformBrowser } from '@angular/common';
import { finalize } from 'rxjs/operators';


declare const windown: any;

const defaultUtilScript = '';


@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss'],
  standalone: false
})

export class SignupComponent implements OnInit {


  signupForm: FormGroup;

  ngTelInput: any;
  showBtnSpinner: boolean = false;
  cuntryCode: number = 0;
  copyRights: number = config.copyrights;
  signupErrMsg: string = '';


  public account = {
    password: null as string | null
  };
  public baseColor = '#FFF';
  public passwordLabel = 'Password strength:';
  // public strengthLabels = ['', '(Weak)', '(Normal)', '(Strong)', '(Great!)'];
  public passwordStrength = ['#DD2C00', '#FF6D00', '#FFD600', '#AEEA00', '#00C853'];
  public strength = 0;

  strengthChanged(strength: number) {
    this.strength = strength;
  }
  hostlogo: any;
  constructor(
    private router: Router,
    private formBuilder: FormBuilder,
    private alert: AlertPopup,
    private userService: UserService,
    private httpLoader: HttpLoader) {
    this.signupForm = formBuilder.group({
      first_name: [null, Validators.compose([Validators.required, ValidationService.namePattern])],
      last_name: [''],
      company_name: [null, Validators.compose([Validators.required])],
      location: [null],
      email_id: [null, Validators.compose([Validators.required, ValidationService.emailValidator])],
      // password: [''],
      phone_no: ['', Validators.compose([Validators.required, ValidationService.phoneNoValidate])],
      // product_type: [null]
    });
  }

  hasError($event: any) {

  }

  getPhoneNumber($event: any) { }

  telInputObject(obj: any) {
    console.log(obj.s.dialCode);
    this.cuntryCode = obj.s.dialCode;

    obj.setCountry('us');
  }

  onCountryChange($event: any) {
    console.log($event);

  }

  ngOnInit() {

  }

  returnToLogin() {
    this.router.navigate(['/login']);
  };


  createNewAcc(data: any): void {
    this.showBtnSpinner = true;
    this.httpLoader.showLoader();

    const payload = {
      first_name: data.first_name,
      last_name: data.last_name,
      company_name: data.company_name,
      email_id: data.email_id,
      password: data.password,
      phone_no: data.phone_no,
      location: data.location
    };

    this.userService.signupNewUser(payload)
      .pipe(
        finalize(() => {
          this.showBtnSpinner = false;
          this.httpLoader.hideLoader();
        })
      )
      .subscribe({
        next: (response: any) => {
          localStorage.setItem('user_id', response.user_id);
          localStorage.setItem('user_role', response.user_role);
          localStorage.setItem('token', response.token);

          this.signupErrMsg = response?.message ||
            'Account created successfully! Redirecting to OTP verification...';

          setTimeout(() => {
            this.signupErrMsg = '';
            this.router.navigate(['/verify_otp']);
          }, 3000);
        },

        error: (err) => {
          this.signupErrMsg = err?.error?.message || 'Account creation failed.';

          setTimeout(() => {
            this.signupErrMsg = '';
          }, 3000);
        }
      });
  }
}

